import Vue from 'vue'
import Router from 'vue-router'
import LocaleManager from './i18n'
import Meta from 'vue-meta'

import LocaleRouter from './components/LocaleRouter.vue'
import Home from './views/Home.vue'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/:lang',
      component: LocaleRouter,
      children: [
        {
          path: '',
          name: 'Home',
          component: Home
        },
        {
          path: 'service/:page',
          name: 'Service',
          component: () => import(/* webpackChunkName: "Service" */ './views/Service.vue')
        },
        {
          path: 'gallery',
          name: 'Gallery',
          component: () => import(/* webpackChunkName: "Service" */ './views/Gallery.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  if (!['en', 'th'].includes(lang)) return next('th')
  if (LocaleManager.locale !== lang) {
    LocaleManager.locale = lang
  }
  return next()
})

export default router
